<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top">
        <a routerLink="/home/dining/prices">
            <h3>Precios /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2> {{ pageTitle }}</h2>
            </div>
        </a>
    </div>
</div>
<div class="content form">
    <form [formGroup]="priceForm">

        <h4>Precio: </h4>
        <mat-form-field appearance="outline" style="width: 500px">
            <input type="number" matInput placeholder="Precio" formControlName="price">
            @if (priceForm.get('price')?.invalid && priceForm.get('price')?.touched) {
            <mat-error>
                @if (priceForm.get('price')?.hasError('required')) {
                El precio es obligatorio
                }
                @if (priceForm.get('price')?.hasError('min')) {
                El precio debe ser mayor a cero
                }
                @if (priceForm.get('price')?.hasError('max')) {
                El precio debe ser menor a 99.99
                }
            </mat-error>
            }
        </mat-form-field>

        <br><br>
        <h4>Precio empresa: </h4>
        <mat-form-field appearance="outline" style="width: 500px">
            <input type="number" matInput placeholder="Precio empresa" formControlName="price_company">
            @if (priceForm.get('price_company')?.invalid && priceForm.get('price_company')?.touched) {
            <mat-error>
                @if (priceForm.get('price_company')?.hasError('required')) {
                El precio empresa es obligatorio
                }
                @if (priceForm.get('price_company')?.hasError('min')) {
                El precio empresa debe ser mayor a cero
                }
                @if (priceForm.get('price_company')?.hasError('max')) {
                El precio empresa debe ser menor a 99.99
                }
            </mat-error>
            }
        </mat-form-field>

        <br><br>
        <h4>Tipo de comida: </h4>
        <mat-form-field appearance="outline" style="width: 500px">
            <mat-select formControlName="mealType">
                @for (option of mealTypeOptions; track option.value) {
                <mat-option [value]="option.value">{{option.display}}</mat-option>
                }
            </mat-select>
            @if (priceForm.get('mealType')?.invalid && priceForm.get('mealType')?.touched) {
            <mat-error>
                Seleccione un tipo de comida
            </mat-error>
            }
        </mat-form-field>

        <br><br />
        <h4>Fecha de inicio: </h4>
        <mat-form-field appearance="outline" style="width: 500px">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="dpStart" formControlName="validFrom">
            <mat-datepicker-toggle matSuffix [for]="dpStart"></mat-datepicker-toggle>
            <mat-datepicker #dpStart></mat-datepicker>
            @if (priceForm.get('validFrom')?.invalid && priceForm.get('validFrom')?.touched) {
            <mat-error>
                La fecha de inicio es obligatoria
            </mat-error>
            }
        </mat-form-field>

        <br><br>
        <h4>Fecha de fin (opcional): </h4>
        <mat-form-field appearance="outline" style="width: 500px">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="dpEnd" formControlName="validUntil">
            <mat-datepicker-toggle matSuffix [for]="dpEnd"></mat-datepicker-toggle>
            <mat-datepicker #dpEnd></mat-datepicker>
        </mat-form-field>

        @if (errorMessage()) {
        <div style="margin-top: 20px;" class="error-message">
            {{ errorMessage() }}
        </div>
        }

        <br><br>
        <div class="buttons">
            <button mat-flat-button id="action" (click)="saveChanges()" [disabled]="isSubmitting">
                {{ submitButtonText }}
            </button>
            <button mat-flat-button id="cancel" routerLink="/home/dining/prices">Cancelar</button>
        </div>
    </form>
</div>